import { call, put, takeLatest } from 'redux-saga/effects';
import {
  CRIAR_AVALIACAO_REQUEST,
  criarAvaliacaoSuccess,
  criarAvaliacaoFailure,
} from '../duck/avaliacao';

import { criarAvaliacao, buscarAvaliacaoPorId } from '../../services/avaliacaoService';

// Worker: Criação da avaliação e busca do doc completo
function* handleCriarAvaliacao(action) {
  try {
    const response = yield call(criarAvaliacao, action.payload);
    const { docRefAvaliacao, idAvaliacao } = response;
    
    if (!docRefAvaliacao) {
      throw new Error('Avaliação não retornou ID');
    }

    // Agora busca os dados completos do Firestore
    const docCompleto = yield call(buscarAvaliacaoPorId, docRefAvaliacao);

    if (!docCompleto) {
      throw new Error('Documento não encontrado no Firestore');
    }

    yield put(criarAvaliacaoSuccess({ docRefAvaliacao, idAvaliacao, device: docCompleto }));
  } catch (error) {
    console.error('[SAGA] Erro ao criar ou buscar avaliação:', error);
    yield put(criarAvaliacaoFailure(error.message || 'Erro ao criar avaliação'));
  }
}

// Watcher
export default function* avaliacaoSaga() {
  yield takeLatest(CRIAR_AVALIACAO_REQUEST, handleCriarAvaliacao);
}
